 <template>
  <b-modal
    class="overflow-scroll"
    size="lg"
    id="attachment-modal"
    ref="attachment-modal"
    hide-footer
    hide-header
    no-close-on-backdrop
    centered
  >
    <img
      class="float-right mt-2 mr-3 cross-button"
      width="15"
      src="@/assets/X.svg"
      @click="hideModal()"
    />
    <div class="modal-header justify-content-left mt-0 mb-0 py-0">
      <div class="modal-title">Attachments</div>
    </div>
    <!-- <div class="row" v-for="attachment in attachmentArray" :key="attachment">
      <div class="col-2 id-class">{{attachment.id}}</div>
      <div class="col-4 document-class">{{attachment.documentName}}</div>
      <div class="col-3 view-class" @click="viewSelectedDocument(attachment)">View</div>
      <div class="col-3 remove-class" @click="removeSelectedDocument(attachment)">Remove</div>
    </div>-->
    <hr />
    <div class="row m-1 attachment-class">
      <div class="col-1 id-class">1</div>
      <div class="col-6">
        <w-file-upload
          :addedFiles="fileAttachments"
          @fileInputChange="getAttachedDocument($event)"
        />
      </div>
      <div class="col-3 mt-2">
        <a
          v-if="fileAttachments"
          @click="showAttachFile(fileAttachments)"
          href="#"
        >{{getAttachmentName(fileAttachments)}}</a>
      </div>
    </div>

    <hr />
  </b-modal>
</template>

<script>
import FileUploader from "../widgets/FileUploader.vue";
import { SummaryServices } from "../services/summaryService";
const SummaryService = new SummaryServices();
export default {
  components: {
    "w-file-upload": FileUploader
  },
  props: ["attachmentArray", "attachmentName", "fileAttachments"],
  data() {
    return {};
  },
  created() {
    this.addFiles = [];
  },
  methods: {
    getAttachmentName(attachment) {
      return attachment.split(/_(.+)/)[1];
    },
    showAttachFile(event) {
      this.loading = true;
      // var fileName = attachment.split(/_(.+)/)[1];
      SummaryService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    },

    hideModal() {
      this.$root.$emit("bv::hide::modal", "attachment-modal");
    },
    viewSelectedDocument(event) {
      console.log(event);
    },
    removeSelectedDocument(event) {
      console.log(event);
    },
    getAttachedDocument(event) {
      console.log(event);
      this.$emit("getAttachedDocument", event);
    }
  }
};
</script>

<style scoped>
.cross-button {
  cursor: pointer;
}
.modal-dialog {
  max-width: 100% !important;
}
.modal-title {
  /* font-family: TitilliumWeb; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 22px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.23;
  letter-spacing: 0.22px;
  text-align: left;
  color: #002d72;
}
.attachment-class {
  background-color: #f8f7f7;
}
.id-class {
  /* font-family: TitilliumWeb; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.06;
  letter-spacing: 0.16px;
  text-align: left;
  color: #2b2b2b;
}
.document-class {
  /* font-family: TitilliumWeb; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.06;
  letter-spacing: 0.16px;
  text-align: left;
  color: #484848;
}
.view-class {
  /* font-family: TitilliumWeb; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.25;
  letter-spacing: 0.16px;
  text-align: left;
  color: #002d72;
}
.remove-class {
  /* font-family: TitilliumWeb; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.06;
  letter-spacing: 0.16px;
  text-align: left;
  color: #e33232;
}
.modal-content {
  width: 100% !important;
  margin: auto;
}
.create-flow-modal {
  background: none !important;
}
.modal-body {
  padding: 0% !important;
}
.modal-header {
  border: none !important;
}
.modal-header {
  color: white;
  background-image: none !important;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.title-style {
  color: #13285b90;
  font-size: 14px;
}
.nav-tabs .nav-link.active {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom: 2px solid #13285b !important;
}
.nav-tabs .nav-link:hover {
  border-color: transparent !important;
  border-bottom: 2px solid #13285b !important;
}
.nav-item > a {
  padding: 0;
}
.flow-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 35px;
  text-align: center;
}
</style>
